import { UserRow } from 'interfaces/bulk_users';

const readFileWithEncoding = async (file: File): Promise<string> => {
  const buffer = await file.arrayBuffer();
  const bytes = new Uint8Array(buffer);

  const hasUtf8Bom =
    bytes[0] === 0xef && bytes[1] === 0xbb && bytes[2] === 0xbf;

  if (hasUtf8Bom) {
    return new TextDecoder('utf-8').decode(buffer);
  }

  const utf8Text = new TextDecoder('utf-8', { fatal: false }).decode(buffer);

  if (!utf8Text.includes('\uFFFD')) {
    return utf8Text;
  }

  return new TextDecoder('windows-1252').decode(buffer);
};

const detectSeparator = (headerRow: string): ',' | ';' =>
  headerRow.includes(';') ? ';' : ',';

const LOWERCASE_WORDS = new Set(['de', 'da', 'do', 'das', 'dos', 'e', 'a', 'o']);

const toTitleCase = (name: string) =>
  name
    .toLowerCase()
    .split(/\s+/)
    .map((word, i) =>
      i === 0 || !LOWERCASE_WORDS.has(word)
        ? word.charAt(0).toUpperCase() + word.slice(1)
        : word
    )
    .join(' ');

export const parseFile = async (file: File): Promise<UserRow[]> => {
  const csv = await readFileWithEncoding(file);

  const [headerRow, ...body] = csv.split('\n').filter(row => row.trim() !== '');

  const separator = detectSeparator(headerRow);
  const headers = headerRow.trim().split(separator);
  const namePosition = headers.indexOf('Nome Completo') !== -1
    ? headers.indexOf('Nome Completo')
    : headers.indexOf('Nome');
  const emailPosition = headers.indexOf('Email');
  const passwordPosition = headers.indexOf('Senha');
  const phoneNumberPosition = headers.indexOf('Telefone');

  return body.map((line: string) => {
    const values = line.trim().split(separator);

    return {
      name: toTitleCase(values[namePosition]?.trim() ?? ''),
      email: values[emailPosition]?.trim().toLowerCase(),
      password: values[passwordPosition]?.trim(),
      phone_number: values[phoneNumberPosition]?.trim()
    };
  });
};
